<template>
  <div class="panel-container">
    <IntegrationConfigCard
      :ats-name="atsName"
      :guidance="guidance"
      :logo-url="logoUrl"
    />
    <v-card
      class="pa-6 integration-connect-card"
      elevation="0"
    >
      <v-card-title class="text-title">
        Connect your ATS
      </v-card-title>
      <v-card-text class="pa-0 mt-7">
        <div class="d-flex align-center text-title mb-4 mt-4">
          <img
            :src="logoUrl"
            :alt="`${atsName}_logo`"
            height="34"
            class="mr-4"
          >{{ atsName }}
        </div>

        <div class="d-flex flex-column">
          <div v-if="srInfo.hasAuthenticatorUrl">
            <p v-if="srInfo.alreadyConnected">
              Your ATS has already been connected.
            </p>
            <div v-else>
              Click below to authorize and initiate your SmartRecruiters integration:
              <DpplAutoSizedButton
                class="mt-8"
                width="277"
                :href="srInfo.connectUrl"
                @click="$emit('submit')"
              >
                Connect {{ atsName }}
              </DpplAutoSizedButton>
            </div>
          </div>
          <p v-else>
            Please email us at
            <a :href="`mailto:${supportEmail}?subject=${atsName} integration question`">
              {{ supportEmail }}</a>
            for assistance with connecting your ATS with Datapeople.
          </p>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DpplAutoSizedButton from '@/components/datapeople/DpplAutoSizedButton.vue';
import IntegrationConfigCard from '@/components/settings/integrations/IntegrationConfigCard.vue';

export default {
  name: 'SmartRecruiters',
  components: {
    DpplAutoSizedButton,
    IntegrationConfigCard,
  },
  props: {
    atsName: { type: String, default: '' },
    guidance: { type: String, default: '' },
    logoUrl: { type: String, default: '' },
    supportEmail: { type: String, default: '' },
    srInfo: { type: Object, default: () => ({}) },
  },
  emits: ['submit'],
};
</script>

<style scoped lang="less">
.integration-connect-card {
  width: calc(50% - 6px);
  height: 250px;
}
</style>
